import { useEffect, useState } from "react";
import {
  getPendingBusinesses,
  approveBusiness,
  rejectBusiness,
} from "../api/menupro.api";
import "./admin.css";

export default function Admin() {
  const [list, setList] = useState([]);

  const load = async () => {
    try {
      const res = await getPendingBusinesses();
      setList(res.data || []);
    } catch (e) {
      const msg = e?.response?.data?.message || "";
      if (e?.response?.status === 401 || msg.includes("ADMIN_UNAUTHORIZED")) {
        window.location.href = "/menupro/admin-login";
      }
    }
  };

  useEffect(() => {
    load();
  }, []);

  const approve = async (id) => {
    await approveBusiness(id);
    load();
  };

  const reject = async (id) => {
    const reason = window.prompt("Rədd səbəbi (istəyə bağlı):", "");
    await rejectBusiness(id, reason || "");
    load();
  };

  return (
    <div className="admin-wrap">
      <div className="admin-card">
        <div className="admin-title">Gözləyən Bizneslər</div>

        {list.length === 0 && (
          <div className="admin-empty">Gözləyən sorğu yoxdur.</div>
        )}

        <div className="admin-list">
          {list.map((b) => (
            <div key={b.id} className="admin-item">
              <h3>{b.businessName}</h3>
              <div className="admin-phone">{b.phone}</div>

              <div className="admin-actions">
                <button className="ok" onClick={() => approve(b.id)}>
                  Qəbul et
                </button>
                <button className="no" onClick={() => reject(b.id)}>
                  Rədd et
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

